import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { listJudicialRecords } from "services/JudicialRecordsService";
import { JudicialRecordsContext } from "./JudicialRecordsContext";
import { Can } from "configs/CASLContext";
import { JudicialRecords, view } from "utils/constants";
import { Button } from "primereact/button";
import ModalView from "./ModalView";
import { OptionApis, OptionStatusJudicial } from "utils/enumSelect";

const JudicialRecordsTable = () => {
    //! define

    const judicialContext = useContext(JudicialRecordsContext);

    const { selectedItem, setCheckLoad, setSelectedItem, lazyParams, setLazyParams, totalRecords, loading, listJudicial, openDialogView, setOpenDialogView } = judicialContext;

    //! state
    const { t, i18n } = useTranslation(["judicial-records", "common"]);
    const toast = useRef(null);
    const dt = useRef(null);

    //! function

    const onPage = (event) => {
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const paginatorJudicialRecords = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const actionBodyVNeID = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions">
                <Can I={view} a={JudicialRecords}>
                    <Button icon="pi pi-eye" className="p-button-rounded p-button mr-2" tooltip={t("view", { ns: "common" })} onClick={() => setOpenDialogView(rowData.id)} />
                </Can>
            </div>
        );
    };

    //! useEffect

    //! render
    return (
        <div className="grid" style={{ width: "100%" }}>
            <div className="col-12">
                <BlockDetail title={t("judicial-records.list", { ns: "judicial-records" })}>
                    <Toast ref={toast} />
                    <DataTable
                        ref={dt}
                        value={listJudicial}
                        selectionMode="single"
                        selection={selectedItem}
                        onSelectionChange={(e) => {
                            setSelectedItem(e.value);
                        }}
                        dataKey="id"
                        className="datatable-responsive p-datatable-sm"
                        showGridlines
                        lazy
                        paginator
                        rows={lazyParams.rows}
                        first={lazyParams.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        loading={loading}
                        paginatorClassName="justify-content-start"
                        paginatorTemplate={paginatorJudicialRecords}
                        emptyMessage="Không có dữ liệu"
                        sortMode="single"
                        sortOrder={1}
                        tableStyle={{ minWidth: "50rem" }}
                    >
                        {/* <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} /> */}
                        <Column
                            body={(rowData) => {
                                return OptionApis.find((item) => item.value === rowData.requestType)?.label;
                            }}
                            header={t("judicial-records.nameApi")}
                            showFilterMatchModes={false}
                            style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }}
                        />
                        <Column field="unitCode" header={t("judicial-records.unitCode")} showFilterMatchModes={false} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                        <Column field="unitName" header={t("judicial-records.unitName")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                        <Column field="profileCode" header={t("judicial-records.profileCode")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                        <Column
                            body={(rowData) => {
                                return rowData.requestType !== 5 ? OptionStatusJudicial.find((item) => item.value === rowData.status)?.tag : OptionStatusJudicial.find((item) => item.value === rowData.status)?.tagReverse;
                            }}
                            header={t("judicial-records.status")}
                            showFilterMatchModes={false}
                            style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }}
                        />
                        <Column field="createdAt" header={t("judicial-records.createdAt")} showFilterMatchModes={false} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                        <Column body={actionBodyVNeID} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                    </DataTable>
                </BlockDetail>
            </div>
            {openDialogView && <ModalView vneidDialog={openDialogView} />}
        </div>
    );
};

export default JudicialRecordsTable;
